import {ListDecorator} from './base/ListDecorator';
import {Store} from '@ngrx/store';
import {IAppStore} from '@app/store';
import {POImage} from '../model/POImage';
import {of} from 'rxjs';
import {translate} from '@ngneat/transloco';

export class POImageListDecorator extends ListDecorator {
  isDelBtn$ = of(true);
  isEditBtn$ = of(true);
  isAddBtn$ = of(true);
  sortIDs = {
    id: true,
    label: true,
  };

  constructor(public store: Store<IAppStore>) {
    super(POImage.type);

    const {tPrefix} = this;
    const mainTPrefix = `${tPrefix}image.`;
    this.title = `${mainTPrefix}title`;
    const translationFields = [
      'delTitle',
      'oneItemTitle',
      'oneItemNewTitle',
      'oneItemNotFound',
    ];
    this.translateTitleFields(mainTPrefix, translationFields);
    const headers = ['id', 'label'];
    this.headers$ = of(headers);
    this.headerCaptions$ = of({
      id: translate('ID'),
      label: translate(`${mainTPrefix}label`),
    });
  }
}
